import DOMPurify from 'dompurify';
import { CODE_INFO_PATTERN } from '~/utils/constant';

function checkLeftCode(tokens: any, idx: any) {
  const token1 = tokens[idx + 1];
  return token1?.meta?.isLeft;
}

export function markdownItThirdPartyCode(md: any) {
  const originalFence = md.renderer.rules.fence;
  md.renderer.rules.fence = (
    tokens: any,
    idx: any,
    options: any,
    env: any,
    self: any,
  ) => {
    const token = tokens[idx];

    const info = token.info;

    if (!CODE_INFO_PATTERN.test(info)) {
      token.info = '';
    }

    if (info === 'mermaid') {
      // 各种流程图
      token.content = DOMPurify.sanitize(token.content);
      return originalFence(tokens, idx, options, env, self);
    }

    const html = originalFence(tokens, idx, options, env, self);
    if (options?.editor?.showRunButton) {
      if (checkLeftCode(tokens, idx)) {
        return html.replace(
          /<span class="md-editor-copy-button" data-tips=.+<\/span>/,
          '<span class="md-editor-run-button" data-tips="运行">运行</span>$&',
        );
      }
    }
    return html;
  };
}
